var exports = {
  "k": "xfd349460--9dbcc7--container",
  "P": "xfd349460--9dbcc7--label",
};

module.exports = exports;
